// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('bankReconciliationAnalysis', {
//         templateUrl: 'views/components/views/bankReconciliationAnalysis/bankReconciliationAnalysis.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'bankReconciliationAnalysisService', 'ttGridFactory', function ($stateParams, utilityService, bankReconciliationAnalysisService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let businessCoBankAccountKeyno = $stateParams.businessco_bankaccount_keyno;

//             vm.model = {
//                 gridReady: false,
//                 setting: {}
//             };

//             vm.grid = new ttGridFactory({
//                 rememberId: 'bankreconciliationanalysis_analysis_grid',
//                 kendo: {
//                     height: '100%',
//                     sortable: true,
//                     aggregate: true,
//                     pager: false,
//                     selectable: false,
//                     filterable: false
//                 }
//             });
            
//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadSetting() {
//                 vm.model.setting = (await bankReconciliationAnalysisService.getSetting({ businessco_bankaccount_keyno: businessCoBankAccountKeyno }))[0];
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region GRID PROCEDURE FUNCTION CALLS

//             async function loadGrid() {
//                 vm.grid.dataTask.loadData = {
//                     method: 3738,
//                     parameters: vm.model.setting
//                 };

//                 vm.model.gridReady = true;

//                 if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//             }

//             // #endregion GRID PROCEDURE FUNCTION CALLS

//             // #region FIELD CHANGE MULTI FUNCTIONS

//             vm.onChanged = function (value, id) {
//                 switch (id) {
//                     case 'balance_date':
//                         if (utilityService.validateWatchValue(value, vm.model.setting.balance_date) !== true) return;

//                         vm.model.setting.balance_date = value;

//                         if (utilityService.validateParmsValue(vm.model.setting.balance_date) !== true) return;

//                         loadGrid();
//                         break;
//                     default:
//                         utilityService.setValueToVariable(value);
//                         break;
//                 }
//             };

//             // #endregion FIELD CHANGE MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadSetting();
//                 loadGrid();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
